export const KA = {
    translations: {
        notifications: 'ნოტიფიკაციები',
        markAllAsRead: 'მონიშნე ყველა როგორც წაკითხული',
        poweredBy: 'იკვებება ბყ',
        settings: 'პარამეტრები',
        removeMessage: 'შეტყობინების წაშლა',
        markAsRead: 'წაკითხულად მონიშვნა',
        markAsUnRead: 'წაუკითხავად მონიშვნა',
        noNewNotification: 'აქ სანახავი ჯერ არაფერია ახალი',
    },
    lang: 'ka',
};
//# sourceMappingURL=ka.js.map